import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from '../brand/Logo';

/**
 * Public landing footer: brand logo + legal links + copyright.
 */
export default function LandingFooter() {
  const { t } = useTranslation();
  const year = '2026';

  return (
    <footer className="border-t border-border-primary mt-8">
      <div className="max-w-6xl mx-auto px-4 py-10 flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="flex flex-col items-center sm:items-start gap-2">
          <Logo to="/" size={28} />
          <p className="text-sm text-text-secondary">{t('home.meta.description')}</p>
        </div>

        <nav className="flex items-center gap-6 text-sm text-text-secondary">
          <Link to="/login" className="hover:text-text-primary">{t('home.hero.login')}</Link>
          <Link to="/register" className="hover:text-text-primary">{t('home.hero.ctaPrimary')}</Link>
          <Link to="/privacy-policy" className="hover:text-text-primary">{t('footer.privacy')}</Link>
          <Link to="/terms-of-service" className="hover:text-text-primary">{t('footer.terms')}</Link>
        </nav>
      </div>
      <div className="max-w-6xl mx-auto px-4 pb-8 text-center sm:text-left">
        <p className="text-xs text-text-muted">{t('footer.copyright', { year })}</p>
      </div>
    </footer>
  );
}
